import { Center, FlexProps, Image, useColorModeValue } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { useLogoColor } from 'hooks'
import React from 'react'

const Wrapper = styled(Center)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  background-size: cover;
  flex-direction: column;
`
const AnimetedImage = styled(Image)`
  animation: blink 1s ease-in-out 0s alternate infinite;
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.2;
    }
    100% {
      opacity: 1;
    }
  }
`

const Loader: React.FC<FlexProps & { color?: string }> = (props) => {
  const logo = useLogoColor()
  const bg = useColorModeValue('white', 'gray.800')
  return (
    <Wrapper zIndex={45} bg={bg} {...props}>
      <AnimetedImage width={170} src={logo} />
    </Wrapper>
  )
}

export default Loader
